import { render } from "./InfoTask.vue?vue&type=template&id=6d2a5a12&ts=true"
import script from "./InfoTask.vue?vue&type=script&lang=ts"
export * from "./InfoTask.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__